import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { DatabusService } from '../../shared/services/databus.service';
import { ValidationService } from '../../shared/services/validation.service';
import { DecodeTicketService } from '../../shared/services/decode-ticket.service';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';

@Component({
  selector: 'app-invalid-ticket',
  templateUrl: './invalid-ticket.component.html',
  styleUrls: ['./invalid-ticket.component.scss']
})
export class InvalidTicketComponent implements OnInit {
  invalidMessage: string = '';
  showMessage: boolean = false;
  showSpinner: boolean = false;
  fullString: string = '';
  previous: string = null;
  scanComplete: boolean = false;

  showError: boolean = false;

  constructor (
    private dataSvc: DatabusService,
    private decoder: DecodeTicketService,
    private validate: ValidationService,
    private router: Router,
    private idle: Idle ) {
      if(this.dataSvc.errorMessage !== '') {
        this.invalidMessage = this.dataSvc.errorMessage;
        this.showMessage = true;
      }
    }

  Finished() {
    this.router.navigate(['/scanticket']);
  }

  ScanAnother() {
    this.router.navigate(['/scananother']);
  }

  ngOnInit() {
    if (!this.idle.isRunning()) {
      this.idle.watch();
    };
  }

  ngOnDestroy() {
    this.dataSvc.errorMessage = '';
  }
}




// WEBPACK FOOTER //
// C:/Magento2/gs-kiosk/src/app/routes/invalid-ticket/invalid-ticket.component.ts